class TabbedCollectionProducts extends HTMLElement {
	connectedCallback() {
		if (this.#initialized) return;
		this.#initialized = true;

		this.tabs = Array.from(this.querySelectorAll('[data-tab-button]'));
		this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));

		if (!this.tabs.length || !this.panels.length) return;

		this.#onClick = (event) => {
			const target = event.target instanceof Element ? event.target.closest('[data-tab-button]') : null;
			if (!target) return;

			event.preventDefault();
			this.activateTab(this.tabs.indexOf(target));
		};

		this.#onKeydown = (event) => {
			const target = event.target instanceof Element ? event.target.closest('[data-tab-button]') : null;
			if (!target) return;

			const currentIndex = this.tabs.indexOf(target);
			if (currentIndex < 0) return;

			let nextIndex = null;

			switch (event.key) {
				case 'ArrowLeft':
				case 'ArrowUp':
					nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
					break;
				case 'ArrowRight':
				case 'ArrowDown':
					nextIndex = (currentIndex + 1) % this.tabs.length;
					break;
				case 'Home':
					nextIndex = 0;
					break;
				case 'End':
					nextIndex = this.tabs.length - 1;
					break;
				default:
					return;
			}

			event.preventDefault();
			this.activateTab(nextIndex, true);
		};

		this.addEventListener('click', this.#onClick);
		this.addEventListener('keydown', this.#onKeydown);

		const activeIndex = Math.max(
			0,
			this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true')
		);

		this.activateTab(activeIndex);
	}

	disconnectedCallback() {
		this.removeEventListener('click', this.#onClick);
		this.removeEventListener('keydown', this.#onKeydown);
		this.#initialized = false;
	}

	activateTab(index, shouldFocus = false) {
		if (index < 0 || index >= this.tabs.length) return;

		this.tabs.forEach((tab, tabIndex) => {
			const selected = tabIndex === index;
			tab.setAttribute('aria-selected', selected ? 'true' : 'false');
			tab.tabIndex = selected ? 0 : -1;
			tab.toggleAttribute('aria-current', selected);
		});

		this.panels.forEach((panel, panelIndex) => {
			panel.hidden = panelIndex !== index;
		});

		if (shouldFocus) {
			this.tabs[index]?.focus();
		}
	}

	#initialized = false;
	/** @type {HTMLElement[]} */
	tabs = [];
	/** @type {HTMLElement[]} */
	panels = [];
	/** @type {(event: MouseEvent) => void} */
	#onClick = () => {};
	/** @type {(event: KeyboardEvent) => void} */
	#onKeydown = () => {};
}

if (!customElements.get('tabbed-collection-products')) {
	customElements.define('tabbed-collection-products', TabbedCollectionProducts);
}
